import { getService } from 'reducers/service';
import ServiceName from '../constants/serviceName';
import { createDropdownOptions } from '../utility/helper';

const getPlacesBySearch = async (value) => {
  const service = getService(ServiceName.Place_lookup);
  const response = await service.find({
    query: {
      search: value,
      IsDeleted: false,
    },
  });
  const data = response || [];
  return data;
};

export const getPersonById = async (value) => {
  const service = getService(ServiceName.ptsPerson);
  const response = await service.get(value);
  const data = response || [];
  return data;
};

export const getPlaceById = async (value) => {
  const service = getService(ServiceName.ptsPlace);
  const response = await service.get(value);
  const data = response || [];
  return data;
};

export const getOffenses = async (value) => {
  const service = getService(ServiceName.ptsStatute);
  const response = await service.find({
    query: {
      Description: value,
      // IsDeleted: false,
    },
  });
  const data = response || [];
  return data;
};

export const getRefValues = async (category) => {
  const service = getService(ServiceName.code_rap_value);

  const response = await service.find({
    query: {
      Category: category,
    },
  });

  const data = response?.data || [];

  const options = createDropdownOptions(data, {
    labelField: 'Code',
    valueField: 'Id',
  });

  return options;
};

const getAddressesBySearch = async (value) => {
  const service = getService(ServiceName.Address_lookup);
  const response = await service.find({
    query: {
      FullAddressText: value,
    },
  });
  const data = response || [];
  return data;
};

export const getAddressById = async (value) => {
  const service = getService(ServiceName.Address_lookup);
  const response = await service.get(value);
  const data = response || [];
  return data;
};

const getVehiclesBySearch = async (value) => {
  const service = getService(ServiceName.VehicleLookup);
  const response = await service.find({
    query: {
      search: value,
    },
  });
  const data = response || [];
  return data;
};

export const getVehicleById = async (value) => {
  const service = getService(ServiceName.VehicleLookup);
  const response = await service.get(value);
  const data = response || [];
  return data;
};

export const validateUserSignature = async ({ ptsUserID, pin }) => {
  const service = getService(ServiceName.rms_user_signature);
  return await service.get({ ptsUserID, pin });
};

const generalServices = {
  getPlacesBySearch,
  getAddressesBySearch,
  getVehiclesBySearch,
};

export default generalServices;
